module.exports = __webpack_public_path__ + "e0cded26167ffb8ae715e50f32081e64.png";